import { useCallback, useSyncExternalStore } from "react";
import { useQuery } from "convex/react";
import { api } from "@constructionautomation/backend";

const STORAGE_KEY = "takeoff-ai-debug-mode";
const CHANGE_EVENT = "takeoff-ai-debug-mode-change";

function readStored() {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function subscribe(onChange: () => void) {
  window.addEventListener("storage", onChange);
  window.addEventListener(CHANGE_EVENT, onChange);
  return () => {
    window.removeEventListener("storage", onChange);
    window.removeEventListener(CHANGE_EVENT, onChange);
  };
}

/**
 * Platform-admin-only switch for AI takeoff diagnostics (API calls, costs, raw evidence,
 * manual coordinates, ad-hoc runs). End users never see these controls.
 */
export function useAiDebugMode() {
  const isPlatformAdmin = useQuery(api.admin.roles.isPlatformAdmin, {}) === true;
  const stored = useSyncExternalStore(subscribe, readStored, () => false);
  const setEnabled = useCallback((next: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      /* Storage can be unavailable; the toggle then lasts only for this event. */
    }
    window.dispatchEvent(new Event(CHANGE_EVENT));
  }, []);
  return { available: isPlatformAdmin, enabled: isPlatformAdmin && stored, setEnabled };
}
